import { Link } from 'react-router-dom';

const AboutHero = () => {
  return (
    <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/60152d6eadb2d5e8675428af057af14a.jpg"
          alt="من نحن"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/85 via-navy/75 to-navy/85"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 relative z-10 text-center">
        {/* Breadcrumb */}
        <div className="flex items-center justify-center gap-2 text-white/80 text-sm mb-6">
          <Link to="/" className="hover:text-primary transition-all-300">
            الرئيسية
          </Link>
          <i className="ri-arrow-left-s-line"></i>
          <span className="text-primary">من نحن</span>
        </div>

        {/* Heading */}
        <h1 className="text-6xl font-bold text-white mb-6">
          من <span className="text-primary">نحن</span>
        </h1>

        {/* Description */}
        <p className="text-xl text-white/90 max-w-2xl mx-auto">
          شركة رائدة في مجال الحلول الأمنية المتكاملة بخبرة تمتد لأكثر من 15 عاماً
        </p>
      </div>
    </section>
  );
};

export default AboutHero;